export default __webpack_public_path__ + "media/Meat-Plant-based.952ad862.png";